import BtnAccueilDesk from "../utils/BtnSubmitDesk/BtnSubmitDesk";
import BtnAccueilTabMob from "../utils/BtnSubmitMobile/BtnSubmitMobile";
import widthScreen from "../utils/widthScreen/widthScreen";

const NavBar = () => {
  const width = widthScreen();
  return (
    <div className="containerNavBar">
      <nav className="navBar">
        {width > 992 ? <BtnAccueilDesk /> : <BtnAccueilTabMob />}
      </nav>
    </div>
  );
};

export default NavBar;
